/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const formValidation = require('base/components/formValidation');
const createErrorNotification = require('base/components/errorNotification');

function assignEvents() {
    $('.login-wrapper .header .back, body > .overlay').on('click', () => {
        const html = $('html');
        const page = $('.page');
        const overlay = $('body > .overlay');

        $('.login-container').removeClass('show');
        html.removeClass('no-overflow');
        overlay.hide();

        if (page.length && page.hasClass('login-open')) {
            page.removeClass('login-open');
        }
    });
}

function updateLoginRegisterPage(e) {
    e.preventDefault();
    const headerLogin = $('#headerLogin');
    const headerRegister = $('#headerRegister');
    const loginCreateAccount = $('.login-create-account');

    if (headerLogin.is(':visible')) {
        loginCreateAccount.fadeOut();
        headerLogin.fadeOut(() => {
            headerRegister.fadeIn();
        });
    } else {
        headerRegister.fadeOut(() => {
            headerLogin.fadeIn();
            loginCreateAccount.fadeIn();
        });
    }

    return false;
}

function socialLogin() {
    // eslint-disable-next-line no-alert
    $('.icon-facebook-color, .icon-google').on('click', (e) => {
        const classIconName = $(e.currentTarget)[0].className;
        const typeOfIcon = classIconName.replace('icon-', '');
        const element = $('.login-oauth ').find(`.oauth-${typeOfIcon}`);

        if (element.length) {
            window.location.href = element.attr('href');
        }
    });
}

function checkHoneypotFields(form) {
    let isBot = false;
    const honeypotFields = form.find('.ohnohoney');

    honeypotFields.each((_i, element) => {
        const thisTarget = $(element);
        if (thisTarget.val() !== '') {
            isBot = true;
        }
    });

    return isBot;
}

module.exports = {
    login() {
        $('form.login').submit((e) => {
            const form = $(e.currentTarget);
            e.preventDefault();
            const url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: (data) => {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        window.location.href = data.redirectUrl;
                    }
                },
                error: (data) => {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                },
            });
            return false;
        });
    },

    register() {
        $('form.registration').submit((e) => {
            const form = $(e.currentTarget);
            e.preventDefault();
            const url = form.attr('action');
            const isBot = checkHoneypotFields(form);

            if (!isBot) {
                form.spinner().start();
                $('form.registration').trigger('login:register', e);
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: (data) => {
                        form.spinner().stop();
                        if (!data.success) {
                            formValidation(form, data);
                            $('form.registration').trigger('login:register:error', data);
                        } else {
                            $('form.registration').trigger('login:register:success', data);
                            if ('redirectUrl' in data) {
                                window.location.href = data.redirectUrl;
                            }
                        }
                    },
                    error: (err) => {
                        if ('responseJSON' in err && 'redirectUrl' in err.responseJSON && err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                        }

                        form.spinner().stop();
                    },
                });
            }

            return false;
        });
    },

    resetPassword() {
        $('.reset-password-form').submit((e) => {
            const form = $(e.currentTarget);
            e.preventDefault();
            const url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: (data) => {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append(`<p>${data.receivedMsgBody}</p>`);
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html(`<a href="
                                    ${data.returnUrl}" class="btn btn-primary btn-block">
                                    ${data.buttonText}</a>`);
                        }
                    }
                },
                error: () => {
                    form.spinner().stop();
                },
            });
            return false;
        });
    },

    assignEvents,
    socialLogin,
    submitHeaderLogin() {
        // eslint-disable-next-line func-names
        $('#headerLogin').submit(function (e) {
            const form = $(this);
            e.preventDefault();
            const url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('.alert', $(form)).remove();
                        $('#headerLogin .login-wrapper').prepend(
                            `<div class="alert alert-danger" role="alert">${data.error.join(
                                '<br/>',
                            )}</div>`,
                        );

                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        if ($('.order-thank-you-msg').length) {
                            window.location.href = data.redirectUrl;
                        } else {
                            window.location.reload();
                        }
                    }
                },
                error(data) {
                    if (data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                },
            });

            return false;
        });
    },

    submitHeaderRegister() {
        // eslint-disable-next-line func-names
        $('#headerRegister, #registerFormExperience').submit((e) => {
            const form = $(e.currentTarget);
            e.preventDefault();
            e.stopPropagation();
            const url = form.attr('action');
            const isBot = checkHoneypotFields(form);

            if (!isBot) {
                form.spinner().start();
                const formRegistration = form.hasClass('registration-experience') ? $('form.registration-experience') : $('form.registration');
                formRegistration.trigger('login:register', e);

                $.ajax({
                    url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success(data) {
                        form.spinner().stop();
                        if (!data.success) {
                            const isExperienceWrapper = form.parents('.login-wrapper-experience').length;
                            const loginWrapper = isExperienceWrapper ? $('.login-wrapper-experience') : $('.login-wrapper');
                            formValidation(loginWrapper, data);
                            if (data.fields) {
                                if (data.fields.dwfrm_profile_login_passwordconfirm) {
                                    const content = data.fields.dwfrm_profile_login_passwordconfirm;
                                    // eslint-disable-next-line no-param-reassign
                                    data.fields.dwfrm_profile_login_password = content;
                                }
                            }
                            if ($('.login-form-nav').length) {
                                formValidation(form, data);
                            } else {
                                formRegistration.trigger('login:error', data);
                                const dangerAlert = $('.alert-danger');
                                if (dangerAlert.length) {
                                    if (isExperienceWrapper) {
                                        $('.login-wrapper-experience').prepend(dangerAlert);
                                    } else {
                                        dangerAlert.insertAfter('.login-wrapper .header');
                                    }
                                }
                            }
                        } else {
                            const isCheckout = $('#checkout-main').length;
                            const isExperienceForm = form.attr('id') === 'registerFormExperience';
                            if (!isCheckout && !isExperienceForm) {
                                window.location.href = data.redirectUrl;
                            } else {
                                window.location.reload();
                            }
                        }
                    },
                    error(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification(
                                $('.error-messaging'),
                                err.responseJSON.errorMessage,
                            );
                        }

                        form.spinner().stop();
                    },
                });
            }

            return false;
        });
    },

    loadForm() {
        $(document.body).on('click', '.back-login-link, .login-create-account-link', (e) => {
            updateLoginRegisterPage(e);
        });
    },
    checkIfIsLoginShow() {
        if ($('.login-page').length) {
            $('body > .login-container').remove();
            $('.account.icon-login, .account.icon-user').hide();
        }
    },
    modalLogin() {
        $('.header-icons .user a').on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            const page = $('.page');
            const overlay = $('body > .overlay');
            const loginInfo = $('.loggin-information');
            const html = $('html');

            const loginComponent = $('.login-container');
            const isLogged = $('.bs-popover-bottom');

            if (isLogged.length === 0) {
                const urlModal = loginComponent.attr('data-url');
                const headerLoaded = $('#headerLogin');
                if (headerLoaded.length === 0) {
                    $.ajax({
                        url: urlModal,
                        type: 'get',
                        success: (data) => {
                            if (data.renderedTemplate) {
                                loginComponent.html('').append(data.renderedTemplate);

                                loginComponent.addClass('show');
                                overlay.show();

                                // eslint-disable-next-line global-require
                                const formHelpers = require('./form');
                                formHelpers.inputFocus();
                                formHelpers.inputPassword();
                                formHelpers.updateInputLabels();
                                formHelpers.clearInvalidFeedBack();

                                if (window.grecaptcha) {
                                    const processInclude = require('base/util');
                                    // eslint-disable-next-line no-unused-vars, import/extensions
                                    const captcha = require('../recaptcha/recaptcha');
                                    processInclude(captcha);
                                }

                                this.login();
                                this.register();
                                this.resetPassword();
                                this.assignEvents();
                                this.socialLogin();
                                this.submitHeaderLogin();
                                this.submitHeaderRegister();
                                this.loadForm();
                                this.checkIfIsLoginShow();
                                this.cancelOauthLogin();
                                this.clearResetForm();
                            }
                        },
                    });
                } else if (loginComponent.hasClass('show')) {
                    loginComponent.removeClass('show');
                    overlay.hide();
                } else {
                    loginComponent.addClass('show');
                    overlay.show();
                }
            } else if (loginInfo.length) {
                if (loginInfo.is(':visible')) {
                    loginInfo.hide();
                    page.removeClass('login-open');
                    overlay.hide();
                } else {
                    loginInfo.show();
                    page.addClass('login-open');
                    overlay.show();
                }
            } else if ($('#headerLogin').length) {
                page.addClass('login-open');
                overlay.show();
                $('.login-container').addClass('show');
                html.addClass('no-overflow');
            } else {
                let url = $('.icon-user').parent().attr('href');
                if (!url) {
                    url = $(e.currentTarget).attr('href');
                }
                window.location.href = url;
            }
        });
    },
    cancelOauthLogin() {
        $('.cancel-oauthlogin').on('click', (e) => {
            e.preventDefault();
            $('.oauth-wrapper').slideUp().remove();
            $('#login-form-email').focus();
        });
    },

    clearResetForm() {
        $('#login .modal').on('hidden.bs.modal', () => {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },
};
